import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=fbb690e8"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbb690e8')) {
      api.createRecord('fbb690e8', component.options)
    } else {
      api.reload('fbb690e8', component.options)
    }
    module.hot.accept("./EmailVerification.vue?vue&type=template&id=fbb690e8", function () {
      api.rerender('fbb690e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/ContactVerification/components/EmailVerification.vue"
export default component.exports